import { render, staticRenderFns } from "./StoreSection.vue?vue&type=template&id=51397e2c&scoped=true&"
import script from "./StoreSection.vue?vue&type=script&lang=js&"
export * from "./StoreSection.vue?vue&type=script&lang=js&"
import style0 from "./StoreSection.vue?vue&type=style&index=0&id=51397e2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51397e2c",
  null
  
)

export default component.exports